import { createContext } from 'react';

export const lngContext = createContext()
